module.exports = __webpack_public_path__ + "media/images/emoticons/fuji-ae311735708b03432c1897e74769a4f1.gif";